import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { BankAccount, BankAccountCreateDTO } from '../interfaces/bank/bankAccount.interface';

export const BankAccountService = {
  listByInstitution: async (institutionId: string): Promise<BankAccount[]> =>
    (await axios.get(ENDPOINTS.BANK_ACCOUNT.LIST_BY_INSTITUTION(institutionId))).data,
  getById: async (id: string): Promise<BankAccount> =>
    (await axios.get(ENDPOINTS.BANK_ACCOUNT.GET_BY_ID(id))).data,
  create: async (dto: BankAccountCreateDTO): Promise<BankAccount> =>
    (await axios.post(ENDPOINTS.BANK_ACCOUNT.CREATE, dto)).data,
  update: async (id: string, dto: BankAccountCreateDTO): Promise<BankAccount> =>
    (await axios.put(ENDPOINTS.BANK_ACCOUNT.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> => {
    await axios.delete(ENDPOINTS.BANK_ACCOUNT.DELETE(id));
  },
};
